import { StyledSpan } from '../../../../../components/styled/StyledSpan';
import styles from './ColorSwatch.module.css';

function ColorSwatch({
	backGroundColorSwatch,
	colorSwatchData,
	midColorSwatch,
}) {
	return (
		<StyledSpan
			className={styles.colorSwatch}
			backGroundColor={backGroundColorSwatch}
		>
			{colorSwatchData.colorData.includes('https:') ? (
				<img src={colorSwatchData.colorData} alt="img" />
			) : (
				<StyledSpan
					className={styles.insideColorSwatch}
					backGroundColor={midColorSwatch}
				></StyledSpan>
			)}
		</StyledSpan>
	);
}
export default ColorSwatch;
